import { Component, Input, OnInit } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../../../store/state.model';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { phone_format } from '../../../common/helpers/utils';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'app-customer-details',
    templateUrl: './customer-details.component.html',
    styleUrls: ['./customer-details.component.scss'],
    imports: [MatCard, MatCardTitle, MatCardContent, MatFormField, MatInput, TranslatePipe]
})
export class CustomerDetailsComponent implements OnInit {
    /**
  * Property to store params loke mode and phone
  **/
     @Input() public customer: object;
  /**
    *@property Values of the screen
    **/
  public bindings = {
    firstName: '',
    lastName: '',
    emails: '',
    phoneNumber: ''
  };

  constructor(
    public reduxState: NgRedux<AppState>,
    public translate: TranslationService,
  ) {
    this.bindings = {
      firstName: '',
      lastName: '',
      emails: '',
      phoneNumber: ''
    };
  }

  ngOnInit() {
    this.getCustomerData();
  }

  /**
    * @function getCustomerData Get the customer info from redux
    **/
  public getCustomerData(): void {
    this.bindings = {
      firstName: !!this.customer ? this.customer['firstName'] : '',
      lastName: !!this.customer ? this.customer['lastName'] : '',
      emails: !!this.customer ? this.customer['emails'][0]['emailAddress'] : '',
      phoneNumber: phone_format(!!this.customer ? this.customer['phoneNumbers'][0]['phoneNumber'] : '')
    };
  }

}
